// Realtime SDK helpers — used on the INSTRUCTOR side for instant updates.
// We're well under the 100 concurrent connection cap because there are only
// 1-2 active instructors at any time.

import { ref, onValue, get, set, update, push, remove } from 'firebase/database'
import { database } from './config.js'

export function subscribe(path, onData, onError) {
  const r = ref(database, path)
  const unsubscribe = onValue(
    r,
    (snapshot) => onData(snapshot.val()),
    (err) => onError?.(err),
  )
  return unsubscribe
}

/** One-shot read of a node — returns the parsed value or null. */
export async function fetchOnce(path) {
  const snapshot = await get(ref(database, path))
  return snapshot.val()
}

export function setNode(path, value) {
  return set(ref(database, path), value)
}

export function updateNode(path, partial) {
  return update(ref(database, path), partial)
}

export function pushChild(path, value) {
  const newRef = push(ref(database, path), value)
  return newRef.key
}

export function removeNode(path) {
  return remove(ref(database, path))
}
